<!-- 板材 -->
<template>
  <BaseFormItem2
    class="board"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <div class="board__content">
      <RadioTable2
        :value="val.board_brand ? `${val.board_brand}_${val.board_tg}` : ''"
        radioKey="board_brand_tg"
        radioLabel="#"
        :showExpand="true"
        :isError="isError"
        :loading="loading"
        :columns="columns"
        :tableData="list"
        @change="handleRowClick"
      >
        <template v-slot:board_brand="{ row }">
          <span>
            {{ row.board_brand.name }}
            <a 
              v-if="row.describe_pdf_url"
              class="board__table__pdf"
              target="_blank"
              :href="row.describe_pdf_url"
              @click.stop
            >
              <img src="@@/assets/img/icons/icon_pdf.png" />
            </a>
          </span>
        </template>
      </RadioTable2>
    </div>
  </BaseFormItem2>
</template>

<script>
import RadioTable2 from '@@/components/radioTable/index2'

import { debounce } from 'throttle-debounce'
import { getFR4Fields } from '@@/utils/getFields'
import { getBoardList } from '@@/api/pcb'

export default {
  props: {
    // 板材品牌
    board_brand: {
      type: String,
      default: ''
    },
    // TG值
    board_tg: {
      type: String,
      default: ''
    },
    // 型号
    board_model: {
      type: String,
      default: ''
    },
    // 板材展示(前端字段)
    view_board: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => ({})
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RadioTable2
  },
  data() {
    return {
      loading: false,
      val: {
        board_brand: this.board_brand,
        board_tg: this.board_tg,
        board_model: this.board_model,
        view_board: ''
      },
      list: [],
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
      debounceGetList: debounce(800, this.getList),
      columns: [
        { label: '板材品牌', prop: 'board_brand', slot: 'board_brand', minWidth: 80 },
        { label: '型号', prop: 'board_model', minWidth: 50, formatter: row => row.board_model.name },
        { label: 'TG值', prop: 'board_tg', minWidth: 40, formatter: row => row.board_tg.name },
        { label: '阻燃性', prop: 'flame_retardancy', minWidth: 40, formatter: row => row.flame_retardancy.name },
        { label: '指定板材费', prop: 'specific_fee', formatter: row => row.specific_fee.name }
      ]
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board')
    },
    // 是否显示未填写样式
    fillTips() {
      const { board_brand } = this.val
      return !board_brand
    }
  },
  watch: {
    board_brand(board_brand) {
      this.val.board_brand = board_brand
    },
    board_tg(board_tg) {
      this.val.board_tg = board_tg
    },
    board_model(board_model) {
      this.val.board_model = board_model
    },
    params(newVal, oldVal) {
      // 默认值：newVal.blayer === 2 && newVal.blind === 0
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal) || (newVal.blayer === 2 && newVal.blind === 0 && !this.list.length)) {
        this.debounceGetList()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let { id } = this.$route.query
      if (!id) {
        this.getList()
      } else {
        this.loading = true
      }
    })
  },
  methods: {
    handleEmit() {
      for (let [key, value] of Object.entries(this.val)) {
        this.$emit(`update:${key}`, value)
      }
      this.isShowError(false)
    },
    handleRowClick(row) {
      const { board_brand, board_tg, board_model } = row || {}
      this.val.board_brand = board_brand.value || ''
      this.val.board_tg = board_tg.value || ''
      this.val.board_model = board_model.value || ''
      this.val.view_board = board_brand.value && board_tg.value ? `${board_brand.name}，${board_model.name}，${board_tg.name}` : ''
      this.handleEmit()
      this.$emit('change', { ...this.val })
    },
    getList() {
      this.loading = true
      getBoardList(this.params)
        .then(res => {
          if (!res) return
          this.list = (res.data || []).map(item => ({ ...item, board_brand_tg: `${item.board_brand.value}_${item.board_tg.value}` }))
          this.handleListChange()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 当前选中行
    isCheckedRow(row) {
      const val = this.val
      return `${val.board_brand}_${val.board_tg}` === `${row.board_brand.value}_${row.board_tg.value}`
    },
    // 列表改变时，判断列表中是否存在当前选中的选项
    handleListChange() {
      // if (this.initPcbParamsChange) return
      const { val, list, fields } = this
      if (list.length) {
        const hasItem = list.some(this.isCheckedRow)
        // 当前选中的选项不在列表中时，清空当前选中的值
        if (!hasItem) {
          // this.val.board_brand = ''
          // this.val.board_tg = ''
          // this.val.board_model = ''
          // this.val.view_board = ''
          // this.handleEmit()
          // this.$emit('change', { ...this.val })
          // this.$topWarning.mergeFields(fields.label)
          // 获取默认选项
          const defaultItem = list.find(i => i.is_checked)
          this.handleRowClick(defaultItem)
        }
      }
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.board__content {
  box-sizing: border-box;
  width: 590px;
  @include media($size: sm) {
    width: 590px;
  }
  @include media($size: md) {
    width: 660px;
  }
  @include media($size: lg) {
    width: 720px;
  }
  .board__table__pdf {
    img {
      vertical-align: text-top;
    }
  }
}
</style>